import React, { Component } from "react";
import moment from "moment";
import API from "../../apiService.js";
import ChartViewer from "../resume/ChartViewer";

class Extenddiagnose extends React.Component {
  render() {
    let data = this.props.data.diagnoses.map((s, y) => {
      return (
        <div key={y} style={{ color: s.log ? "red" : " " }}>
          {s.icd_code} - {s.icd_name}
        </div>
      );
    });
    return <div className="row">{data}</div>;
  }
}

class Extendobat extends React.Component {
  render() {
    let history = this.props.data;
    
    return (
      <div className="row">
        {history.prescribes.length > 0
          ? history.prescribes.map((s, y) => {
              if (s.combination_name === "") {
                return (
                  <div key={y}>
                    {(s.details.length > 0 ? s.details[0].drug.name : '-') +
                      " (" +
                      (s.details.length > 0 ? s.details[0].qty : 0) +
                      ")" +
                      " (" +
                      s.signa.name +
                      ")"}
                  </div>
                );
              } else {
                return (
                  <div key={y}>
                    {"Nama Kombinasi : " +
                      s.combination_name +
                      " (" +
                      s.combination_qty +
                      ")" +
                      " (" +
                      s.signa.name +
                      ")"}
                    {s.details.map((x, y) => {
                      return (
                        <div
                          style={{
                            paddingLeft: "10px"
                          }}
                          key={y}
                        >
                          {"+ " + x.drug.name + " (" + x.qty + ")"}
                        </div>
                      );
                    })}
                  </div>
                );
              }
            })
          : ""}
      </div>
    );
  }
}

export default class Resume extends Component {
  constructor(props) {
    super(props);
    this.state = {
      histories: []
    };
  }
  onReload = () => {
    this.props.history.push("/pelayanan");
  };
  componentDidMount() {
    this.getHistories();
  }
  getHistories = async () => {
    const res = await API.get(
      "registration/history/" + this.props.detilPx.patients.id
    );
    if (res.code === 200) {
      let histories = res.data.histories.data.reverse();
      this.setState({
        histories: histories
      });
    }
  };

  render() {
    // console.log(this.state);
    let tanggal = this.state.histories.map((data, key) => {
      return <td key={key}>{data.created_at}</td>;
    });
    let bb = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0] ? data.examinations[0].weight:''}</td>;
    });
    let tb = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0] ? data.examinations[0].height: ''}</td>;
    });
    let sistole = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0]? data.examinations[0].sistole:''}</td>;
    });
    let diastole = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0]? data.examinations[0].diastole:''}</td>;
    });
    let pulse = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0]? data.examinations[0].pulse:''}</td>;
    });
    let respiration = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0]?data.examinations[0].respiration:''}</td>;
    });
    let temperature = this.state.histories.map((data, key) => {
      return <td key={key}>{data.examinations[0]? data.examinations[0].temperature:''}</td>;
    });
    let Diagnose = this.state.histories.map((data, key) => {
      if (data.diagnoses.length > 0) {
        return (
          <td key={key} scope="col">
            {" "}
            <Extenddiagnose data={data} />
          </td>
        );
      } else {
        return <td key={key}></td>;
      }
    });

    let prescribe = this.state.histories.map((data, key) => {
      if (data.diagnoses.length > 0) {
        return (
          <td key={key} scope="col">
            {" "}
            <Extendobat data={data} />
          </td>
        );
      } else {
        return <td key={key}></td>;
      }
    });
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <h3>Resume Pelayanan</h3>
          </div>
          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <table className="table align-items-center table-flush table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" style={{ textAlign: "center" }}>
                        <h3>BB dan TB</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="col">
                        <h4>Tanggal</h4>
                      </td>
                      {tanggal}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>BB (Kg)</h4>
                      </td>
                      {bb}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>TB (Cm)</h4>
                      </td>
                      {tb}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card-body">
                <div className="col-md-11">
                  {" "}
                  <ChartViewer histories = {this.state.histories} id={this.props.detilPx.patients.id} />{" "}
                </div>

                <table className="table align-items-center table-flush table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" style={{ textAlign: "center" }}>
                        <h3>Vital Sign</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="col">
                        <h4>Tanggal</h4>
                      </td>
                      {tanggal}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>sistole</h4>
                      </td>
                      {sistole}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>diastole</h4>
                      </td>
                      {diastole}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>Nadi</h4>
                      </td>
                      {pulse}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>Pernapasan</h4>
                      </td>
                      {respiration}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>Suhu</h4>
                      </td>
                      {temperature}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card-body">
                <table className="table align-items-center table-flush table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" style={{ textAlign: "center" }}>
                        <h3>Diagnosa</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="col">
                        <h4>Tanggal</h4>
                      </td>
                      {tanggal}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>Diagnosa</h4>
                      </td>
                      {Diagnose}
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="card-body">
                <table className="table align-items-center table-flush table-responsive">
                  <thead className="thead-light">
                    <tr>
                      <th colSpan="6" style={{ textAlign: "center" }}>
                        <h3>Obat</h3>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="col">
                        <h4>Tanggal</h4>
                      </td>
                      {tanggal}
                    </tr>
                    <tr>
                      <td scope="col">
                        <h4>Obat</h4>
                      </td>
                      {prescribe}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-danger" onClick={this.onReload}>
              Tutup
            </button>
          </div>
        </div>
      </div>
    );
  }
}
